export const CLIENT_NOTES_QUERY_KEY = 'clientNotes'
export const CLIENT_NOTES_BRIEFS_QUERY_KEY = 'clientNotesBriefs'
